import { useCallback, useEffect } from 'react';
import cn from 'classnames';

import Button from "../Button/Button";

import styles from "./modal.module.css";
import close from "../../icons/XCircle.svg";

export default function Modal({isOpen, title, setOpen, onSave, children, button}) {
  const closeModal = () => {
    setOpen(false)
  }

  const handleEscKeyPress = useCallback(
    (event) => event.key === 'Escape' && closeModal(),
    [closeModal]
  );

  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
    isOpen && document.addEventListener('keydown', handleEscKeyPress);

    return () => isOpen && document.removeEventListener('keydown', handleEscKeyPress);
  }, [isOpen, handleEscKeyPress]);

  return (
    <div
      className={cn(styles.container, {[styles.container_hidden]: !isOpen })}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          closeModal();
        }
      }}
    >
      <div className={cn(styles.modal, {[styles.modal_hidden]: !isOpen})}>
        <div className={styles.header}>
          <img className={styles.closeIcon} onClick={closeModal} src={close}/>
          <h2 className={styles.title}>{title}</h2>
        </div>
        <div className={styles.body}>
          {children}
        </div>
        <div className={styles.footer} onClick={onSave}>
          <Button onClick={closeModal} text='Сохранить'/>
          {button && button}
        </div>
      </div>
    </div>
  )
}